
import axiosInstance from './AxiosInstance';

// Fetch POs with pagination and sorting
const fetchPO = async (page = 1, pageSize = 10, sortBy = "", order = "asc",searchTerm={}) => {
  const queryObj = { ...searchTerm,page, pageSize,};
  if (sortBy) {
    queryObj.sortBy = sortBy;
    queryObj.order = order;
    
  }
  Object.keys(queryObj).forEach((key) => {
    if (!queryObj[key]) {
      delete queryObj[key];
    }
  });

  try {
    const response = await axiosInstance.get('/exceptions', { params: queryObj });
    return response.data;
  } catch (error) {
    console.error('Error fetching POs:', error);
    throw error;
  }
};

// Fetch PO details by exception ID
const fetchPODetails = async (poExceptionId) => {
  try {
    const response = await axiosInstance.get('/exceptions', {
      params: { poExceptionId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PO details:', error);
    throw error;
  }
};

// Fetch a specific PO by its ID
const fetchPOById = async (poExceptionId) => {
  try {
    const response = await axiosInstance.get('/exceptions', {
      params: { poExceptionId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PO by ID:', error);
    throw error;
  }
};

// Fetch POs by PO number
const fetchPONumber = async (poNumber) => {
  try {
    const response = await axiosInstance.get('/exceptions', {
      params: { poNumber },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PO by number:', error);
    throw error;
  }
};

// Create a new PO
const createPO = async (data) => {
  console.log("createpo",createPO);
  try {
    const response = await axiosInstance.post('/exceptions', data);
    return response.data;
  } catch (error) {
    console.error('Error creating PO:', error);
    throw error;
  }
};

const getPODetails = async (poNumber) => {
  console.log("Fetching data for PO number:", poNumber);
  try {
    const response = await axiosInstance.get('/podetails', {
      params: { poNumber }, 
    });
    return response.data; 
  } catch (error) {
    console.error("Error checking PO number:", error);
    throw new Error("PO number not found"); 
  }
}

export { 
  fetchPO, 
  fetchPODetails, 
  fetchPOById, 
  fetchPONumber, 
  createPO,
  getPODetails,
};
